// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversionContainer {
  padding-left: 74px;
  padding-right: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding-bottom: 40px;
}

.conversionContainer ul p {
  margin-bottom: 0;
  margin-top: 8px;
}

@media (max-width: 800px) {
  .conversionContainer {
    padding-right: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 500px) {
  .conversionContainer {
    padding-right: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Beacon2RITools/ConversionVCFBFF.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":[".conversionContainer {\n  padding-left: 74px;\n  padding-right: 16px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding-bottom: 40px;\n}\n\n.conversionContainer ul p {\n  margin-bottom: 0;\n  margin-top: 8px;\n}\n\n@media (max-width: 800px) {\n  .conversionContainer {\n    padding-right: 16px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 500px) {\n  .conversionContainer {\n    padding-right: 16px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
